<template>
    <div class="sell-page">
        <div class="top-image">
            <img v-lazy="`https://assets.rurushishi.com/yq-rs-make/car/mobile/images/sell-top-header.png`" class="fix-bnr-img"/>
        </div>
        <div class="notice">
          <div class="icon">
            <div class="iconfont uc-notice nt-icon"></div>
          </div>
          <div class="content">
            <ul class="scroll-list" :class="{marquee_top:animate}">
              <li v-for="(item, index) in marqueeList" :key="index"><span class="nt">{{item}}</span></li>
            </ul>
          </div>
        </div>

        <div class="form">
          <div class="fm-title">给爱车估个价</div>
          <div class="fm-row"><div class="field">汽车品牌</div><div class="value" @click="openBrand=true"><div class="mask"></div><input v-model="formData.manufactor" type="text" placeholder="请选择车品牌" placeholderClass="fdc-ph" /><i class="iconfont uc-jinru"></i></div></div>
          <div class="fm-row"><div class="field">汽车型号</div><div class="value"><input type="text" v-model="formData.extinfo.carModel"  placeholder="请输入车型" placeholderClass="fdc-ph" /></div></div>
          <div class="fm-row"><div class="field">上牌时间</div><div class="value" @click="$refs.plateDatePicker.open()"><div class="mask"></div><input type="text" v-model="formData.extinfo.plateDate" placeholder="请选择上牌时间" placeholderClass="fdc-ph" /><i class="iconfont uc-jinru"></i></div></div>
          <div class="fm-row"><div class="field">行驶公里</div><div class="value"><input type="text" v-model="formData.extinfo.fuelMileage"  placeholder="请输入行驶公里数" placeholderClass="fdc-ph" /><span class="unit">Km</span></div></div>
          <div class="btn-row">
            <button class="btn-find btn-1-clr" @click="atShopEvaluate">到店估价</button>
            <button class="btn-find btn-2-clr" @click="atHomeEvaluate">上门估价</button>
          </div>
        </div>

        <div class="sell-process">
          <div class="title">卖车流程</div>
          <div class="process">
            <div :class="serviceTabIndex === 0 ? 'step active-step' : 'step'" @click="changeSwiper(0)">
              <div class="iconfont uc-yuyuejilu"></div>
              <div class="text">预约</div>
            </div>
            <div :class="serviceTabIndex === 1 ? 'step active-step' : 'step'" @click="changeSwiper(1)">
              <div class="iconfont uc-qianyuejilu"></div>
              <div class="text">评估</div>
            </div>
            <div :class="serviceTabIndex === 2 ? 'step active-step' : 'step'" @click="changeSwiper(2)">
              <div class="iconfont uc-guohu"></div>
              <div class="text">过户</div>
            </div>
          </div>
          <div class="details">
            <swiper class="service_swiper" ref="processSwiper" :options="ProcessSwiperOption">
                <swiperSlide v-for="(item, index) in [1,2,3]" :key="'ss' + index">
                  <img :src="`https://assets.rurushishi.com/yq-rs-make/car/mobile/images/sell-pic-proc-${item}.png`" class="step-pics"/>
                </swiperSlide>
                <div class="process-swiper-pagination" slot="pagination" style="display:none"></div>
            </swiper>
          </div>
        </div>

        <div class="sell-pori">
          <div class="title">卖车优势</div>
          <div class="sp-items">
            <div class="right">
              <img v-lazy="`https://assets.rurushishi.com/yq-rs-make/car/mobile/images/pro-1.png`" class="pro-1"/>
            </div>
            <div class="left">
              <div class="up">
                <img v-lazy="`https://assets.rurushishi.com/yq-rs-make/car/mobile/images/quick-pick.png`" class="pro-s"/>
              </div>
              <div class="down">
                <img v-lazy="`https://assets.rurushishi.com/yq-rs-make/car/mobile/images/pro-service.png`" class="pro-s"/>
              </div>
            </div>
          </div>
        </div>
        <brands-select :openBrandBox="openBrand" v-on:onClosed="openBrand = false" v-on:onSelected="onConfirmBrand"/>
        <mt-datetime-picker
            ref="plateDatePicker"
            type="date"
            @confirm="confirmPlateDateTime"
            :start-date="new Date('2000/01/01')"
            :end-date="new Date()"
            @touchmove.native.stop.prevent
            year-format="{value}"
            month-format="{value}"
            date-format="{value}"
            hour-format="{value}"
            minute-format="00"
            >
        </mt-datetime-picker>
        <mt-datetime-picker
            ref="reserveTimePicker"
            type="datetime"
            @confirm="confirmReserveTime"
            :start-date="new Date()"
            @touchmove.native.stop.prevent
            year-format="{value}"
            month-format="{value}"
            date-format="{value}"
            hour-format="{value}"
            minute-format="00"
            >
        </mt-datetime-picker>
    <mt-popup
      v-model="atHome"
      class="mt-popup"
      position="bottom"
    >
    <div class="popup-container">
        <div class="title">
          <h3>预约上门</h3>
        </div>
        <div class="content">
          <div class="form-reserve">
            <div class="row">
              <div class="title">上门地址</div>
              <div class="field">
                <input type="text" v-model="formData.useraddress" placeholder="请输入您的居住地址" class="txt-field"/>
              </div>
            </div>
            <div class="row">
              <div class="title">预约时间</div>
              <div class="field" @click="$refs.reserveTimePicker.open()">
                <div class="mask"></div>
                <input type="text" v-model="formData.plantime" placeholder="请选择上门时间" class="txt-field"/>
                <i class="iconfont uc-jinru"></i>
              </div>
            </div>
            <div class="row">
              <div class="title">手机号码</div>
              <div class="field">
                <input type="text" v-model="formData.mobile" placeholder="请输入您的手机号码" class="txt-field"/>
              </div>
            </div>
          </div>
        </div>
        <div class="btn-row">
          <button class="btm-popup-ok" @click="onConfirmReserveAtHome">立即预约</button>
        </div>
      </div>
    </mt-popup>
    <mt-popup
      v-model="atShop"
      class="mt-popup"
      position="bottom"
    >
    <div class="popup-container">
        <div class="title">
          <h3>预约到店</h3>
        </div>
        <div class="content">
          <div class="form-reserve">
            <div class="row">
              <div class="title">到店时间</div>
              <div class="field" @click="$refs.reserveTimePicker.open()">
                <div class="mask"></div>
                <input type="text" v-model="formData.plantime" placeholder="请选择上门时间" class="txt-field"/>
                <i class="iconfont uc-jinru"></i>
              </div>
            </div>
            <div class="row">
              <div class="title">手机号码</div>
              <div class="field">
                <input type="text" v-model="formData.mobile" placeholder="请输入您的手机号码" class="txt-field"/>
              </div>
            </div>
          </div>
        </div>
        <div class="btn-row">
          <button class="btm-popup-ok" @click="onConfirmReserveAtShop">立即预约</button>
        </div>
      </div>
    </mt-popup>
    </div>
</template>

<script>
import { MessageBox, Popup, DatetimePicker, Toast } from 'mint-ui'
import "swiper/dist/css/swiper.css"
import { swiper, swiperSlide } from "vue-awesome-swiper"
import util from "@/utils/utils"
import * as comreq from "@/utils/comreq"
import { createClue } from './api'
import { deepClone } from './utils'
import { mapState } from "vuex"
import Cookies from "js-cookie"
import brandsSelect from './components/widget/brandsSelect'

export default {
  components: {
    swiper,
    swiperSlide,
    brandsSelect,
    [Popup.name]: Popup,
    [DatetimePicker.name]: DatetimePicker
  },
  props: {},
  data() {
    return {
        atHome: false,
        atShop: false,
        sellStep: 1,
        animate: false,
        openBrand: false,
        marqueeList: [
            '曲靖  181****914  购买了一台2014款奥迪A3',
            '昆明  138****512  购买了一台2016款吉利博瑞',
            '曲靖  188****832  购买了一台2011款大众途安',
            '昭通  150****359  购买了一台2016款日产轩逸',
            '文山  182****785  购买了一台2013款大众cc',
            '曲靖  181****744  购买了一台2016款马自达昂克塞拉',
            '昭通  176****701  购买了一台2014款别克君威',
            '曲靖  181****264  购买了一台2017款现代名图',
            '曲靖  188****966  购买了一台2015款大众捷达',
            '曲靖  155****381  购买了一台2016本田思域'
        ],
        ProcessSwiperOption: {
          pagination: {
              el: ".process-swiper-pagination",
              clickable :true,
          },
          initialSlide: 0,
          on: {
            paginationUpdate: ({ realIndex })=> {
              this.serviceTabIndex = realIndex
            }
          }
        },
        serviceTabIndex: 0,
        activeTabId: "",
        formData: {
            username: "",//客户姓名
            mobile: "",//客户电话
            manufactor: "",//厂家（品牌）
            plantime: "",
            useraddress: "",
            extinfo: {
                plateDate: "",
                fuelMileage: "",
            }
        }
    };
  },
  filters: {

  },
  watch: {},
  computed: {
    ...mapState([
      "userInfo"
    ])
  },
  methods: {
    changeSwiper(index){
      this.$refs.processSwiper.swiper.pagination.bullets[index].click()
    },
    validateMainForm(){
        const {manufactor, extinfo: {plateDate, fuelMileage} } = this.formData
        if(manufactor.length === 0){
            Toast('请选择汽车品牌!')
            return false
        }
        if(plateDate.length === 0){
            Toast('请选择上牌时间!')
            return false
        }
        if(fuelMileage.length === 0){
            Toast('请输入汽车行驶公里数！')
            return false
        }
        return true
    },
    atShopEvaluate(){//到店评估
        const vret = this.validateMainForm()
        if(vret){
            this.atShop = true
        }
    },
    atHomeEvaluate(){//上门评估
        const vret = this.validateMainForm()
        if(vret){
            this.atHome = true
        }
    },
    resetFormData(){//重置表单
        Object.keys(this.formData).forEach(key => {
            if(key === 'extinfo'){
                Object.keys(this.formData.extinfo).forEach(ikey => {
                    this.formData.extinfo[ikey] = ""
                })
            }else{
                this.formData[key] = ""
            }
        })
    },
    onConfirmReserveAtHome(){
        const formData = deepClone(this.formData)
        formData.atype = 4 //上门评估
        if(formData.plantime.length === 0){
            Toast('请选择上门时间！')
            return ;
        }
        if(!/^1\d{10}$/ig.test(formData.mobile)){
            Toast('请输入正确的手机号')
            return ;
        }
        this.submitData(formData)
    },
    onConfirmReserveAtShop(){
        const formData = deepClone(this.formData)
        formData.atype = 5 //到店评估
        if(formData.plantime.length === 0){
            Toast('请选择到店时间！')
            return ;
        }
        if(!/^1\d{10}$/ig.test(formData.mobile)){
            Toast('请输入正确的手机号')
            return ;
        }
        this.submitData(formData)
    },
    submitData(formData){//提交数据
        const {user : {appid, openid, name, nickname}} = this.userInfo
        formData.refereeopenid = openid
        formData.appid = appid
        formData.username = name || nickname
        formData.extinfo = JSON.stringify(formData.extinfo)
        createClue(formData).then(res => {
            if(res.data){
                MessageBox('提交成功', '我们将尽快回复您！');
                this.atHome = false
                this.atShop = false
                this.resetFormData()
            }else{
                MessageBox('提交失败', '请重新打开页面再试！');
            }
        })
    },
    confirmPlateDateTime(newTime){//选择上牌时间确认回调
        this.formData.extinfo.plateDate = newTime.getFullYear() + 
        '-' + (newTime.getMonth() + 1).toString().padStart(2,"0") +
        '-' + newTime.getDate().toString().padStart(2,"0")
    },
    confirmReserveTime(newTime){//选择预约时间确认回调
        this.formData.plantime = newTime.getFullYear() + 
        '-' + (newTime.getMonth() + 1).toString().padStart(2,"0") + 
        '-' + newTime.getDate().toString().padStart(2,"0") + 
        ' ' + newTime.getHours().toString().padStart(2,"0") + ':00:00'
    },
    onConfirmBrand(item){//确认品牌回调
      this.formData.manufactor = item.name
      this.openBrand = false
    },
    showMarquee() {//滚动
        this.animate = true;
        setTimeout(() => {
            this.marqueeList.push(this.marqueeList[0]);
            this.marqueeList.shift();
            this.animate = false;
        },500)
    }
  },
  created() {

  },
  mounted() {
    setInterval(this.showMarquee, 2500)
  }
};
</script>
<style lang="scss" scoped>

.sell-page{
    width: 100%;
    .top-image{
        width: 100%;
        .fix-bnr-img{
            width: 100%;
            height: 3.3rem;
        }
    }
    input::placeholder{
        background: #F5F8FA;
        color:#ccc;
    }
    .notice{
        width: 100%;
        padding: 0.15rem 0.2rem;
        display: flex;
        background-color: #fff;
        box-sizing: border-box;
        .icon{
            display: flex;
            justify-content: center;
            align-items: center;
            .nt-icon{
                font-size: 0.36rem;
                color:#EC8239;
            }
        }
        .content{
            flex: 1;
            display: flex;
            align-items: center;
            overflow: hidden;
            position: relative;
            color: #888;
            font-size: 0.24rem;
            padding-left: 0.1rem;
            height: .4rem;
            .scroll-list{
                position: absolute;
                top: 0;
                left: .1rem;
                li{
                    height: 0.4rem;
                    .nt{
                        line-height: 0.4rem;
                    }
                }
            }
            .marquee_top {
                transition: all 0.5s;
                margin-top: -.4rem;
            }
        }
        box-shadow: 0px 4px 15px 0px rgba(0, 0, 0, 0.06)
    }
    .form{
        margin:0.3rem;
        background:#fff;
        padding: 0.3rem 0px 0.1rem 0px;
        border-radius: 7px;
        box-shadow: 0px 4px 15px 0px rgba(0, 0, 0, 0.06);
        .fm-title{
            font-size: 0.28rem;
            color:#555;
            padding-left: 0.3rem;
        }
        .fm-row{
            height: 0.8rem;
            display: flex;
            border-radius: 40px;
            background: #F5F8FA;
            margin: 0.25rem;
            align-items: center;
            font-size: 0.26rem;
            .field{
                width: 1.8rem;
                text-indent: 0.5rem;
                color:#555;
                border-right: solid 1px #999;
            }
            .value{
                flex: 1;
                padding-left: 0.25rem;
                position: relative;
                input{
                    background:#F5F8FA;
                    color:#333;
                }
                .uc-jinru{
                    position: absolute;
                    right: .2rem;
                    top:.05rem;
                    color:#999;
                    font-size: .3rem;
                }
                .unit{
                  position:absolute;
                  right: .3rem;
                  color: #888;
                  top: .08rem;
                }
            }
        }
        .btn-row{
            padding: 0.5rem .3rem 0.3rem .3rem;
            display: flex;
            justify-content: space-between;
            .btn-find{
                width: 2.5rem;
                height: 0.8rem;
                border-radius: 40px;
                color:#fff;
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: 0.26rem;
            }
            .btn-1-clr{
                background: linear-gradient(135deg, #18B7F9, #0C85FF);
                box-shadow: 0px 0.07rem 0.13rem 0px rgba(24, 183, 249, 0.2);
            }
            .btn-2-clr{
                background: linear-gradient(135deg, #EC8239, #F1A056);
                box-shadow: 0px 0.07rem 0.13rem 0px  rgba(237, 137, 63, 0.45);
            }
        }
    }
    .sell-process{
        margin: 0.3rem;
        background:#fff;
        padding: 0.2rem;
        border-radius: 7px;
        box-shadow: 0px 4px 15px 0px rgba(0, 0, 0, 0.06);
        .title{
            font-size: 0.28rem;
            color:#555;
            padding: 0.1rem 0px;
        }
        .process{
            display: flex;
            padding: 0.1rem;
            justify-content: space-between;
            .step{
                width: 1.8rem;
                height: 1.8rem;
                display: flex;
                flex-direction: column;
                align-items: center;
                background-color: rgba(0, 157, 254, .1);
                border-radius: 7px;
                .iconfont{
                    font-size: 0.6rem;
                    color: #009DFE;
                    text-align: center;
                    padding: 0.3rem;
                }
                .text{
                    text-align:center;
                    font-size: 0.26rem;
                    color: #009DFE;
                }
            }
            .active-step{
              background-color: rgba(236, 130, 57, .1);
              .iconfont{
                    font-size: 0.6rem;
                    color: #EC8239;
                    text-align: center;
                    padding: 0.3rem;
                }
                .text{
                    text-align:center;
                    font-size: 0.26rem;
                    color: #EC8239;
                }
            }
        }
        .details{
            margin: 0.1rem;
            background:#f1f1f1;
            display: flex;
            justify-content: center;
            align-items: center;
            .step-pics{
                width: 6.6rem;
                height: 2.4rem;
                border-radius: 5px;
            }
        }
    }
    .sell-pori{
        margin: 0.3rem;
        background:#fff;
        padding: 0.2rem;
        border-radius: 7px;
        box-shadow: 0px 4px 15px 0px rgba(0, 0, 0, 0.06);
        .title{
            font-size: 0.28rem;
            color:#555;
            padding: 0.1rem 0px;
        }
        .sp-items{
            display: flex;
            padding: 0.1rem 0px;
            justify-content: space-between;
            .pro-1{
                border-radius: 5px;
                width: 3.6rem;
                height: 3rem;
            }
            .pro-s{
                border-radius: 5px;
                width: 2.6rem;
                height: 1.4rem;
            }
            .right{
                width: 3.6rem;
                height: 3rem;
                border-radius: 5px;
                background:#f1f1f1;
                border-radius: 7px;

            }
            .left{
                width: 2.6rem;
                display: flex;
                flex-direction: column;
                .up{
                    width: 2.6rem;
                    height: 1.4rem;
                    background:#f1f1f1;
                    border-radius: 7px;
                }
                .down{
                    width: 2.6rem;
                    height: 1.4rem;
                    margin-top: 0.2rem;
                    background:#f1f1f1;
                    border-radius: 7px;
                }
            }
        }
    }
}
.mask{
  position: absolute;
  top: 0rem;
  left: 0rem;
  right: 0rem;
  bottom: 0rem;
  opacity: 0;
  z-index: 3;
}
.mt-popup {
    width: 100%;
    min-height: 2rem;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    overflow: hidden;
    .popup-container {
        width: 100%;
        height: 100%;
        background-color: white;
        .title {
            display: flex;
            color: #333;
            padding: .2rem;
            .h3 {
            font-size: .263rem;
            }
        }
        .content{
            color:#333;
            padding: .13rem .2rem;
            line-height: .23rem;
            .form-reserve{
                display: flex;
                flex-direction: column;
                .row{
                    display: flex;
                    padding: .2rem 0rem;
                    .title{
                    width: 1.3rem;
                    font-size: .23rem;
                    }
                    .field{
                      flex: 1;
                      border-radius: 5px;
                      display:flex;
                      align-items: center;
                      background:#f5f5f5;
                      box-sizing:border-box;
                      padding-left: .15rem;
                      margin-right: .1rem;
                      position: relative;
                      input{
                          background: #f5f5f5;
                          width: 100%;
                      }
                      .txt-area{
                          width: 100%;
                          background: transparent;
                          padding-top:.1rem;
                      }
                      .uc-jinru{
                          position: absolute;
                          right: .35rem;
                          color:#999;
                      }
                  }
                }
                ::placeholder{
                    color:#888;
                    font-size: .23rem;
                }
            }
        }
        .btn-row{
            padding:.3rem;
            text-align: center;
        }
        .mt-picker {
        }
    
    }
    .btm-popup-ok{
        border: none;
        outline: none;
        padding: .2rem 1.3rem;
        font-size: .23rem;
        border-radius: 3rem;
        color:#fff;
        background: linear-gradient(135deg, #18B8F9, #0C86FF);
        box-shadow: 1px 14px 25px 0px rgba(24, 184, 249, 0.2);
      }
}
</style>